import { render, staticRenderFns } from "./AddStore.vue?vue&type=template&id=f2b0a386"
import script from "./AddStore.vue?vue&type=script&lang=js"
export * from "./AddStore.vue?vue&type=script&lang=js"
import style0 from "./AddStore.vue?vue&type=style&index=0&id=f2b0a386&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports